export default function Methods() {
  return (
    <div className="animate-fade-in pt-6" data-testid="methods-page">
      <h1 className="font-serif text-3xl text-[color:var(--ivoire)]">Méthodes & sources</h1>
      <p className="text-sm text-[color:var(--ivoire-muted)] mt-2">
        D'où viennent les exercices et les sons.
      </p>

      <section className="mt-8">
        <p className="font-mono text-[10px] tracking-widest uppercase text-[color:var(--sauge-light)] mb-3">Exercices proposés</p>
        <ul className="space-y-3 text-sm text-[color:var(--ivoire-muted)] leading-relaxed">
          <li><span className="text-[color:var(--ivoire)] font-medium">Respiration douce</span> — techniques respiratoires simples et confortables.</li>
          <li><span className="text-[color:var(--ivoire)] font-medium">Relaxation musculaire progressive</span> — contractions légères suivies de relâchements.</li>
          <li><span className="text-[color:var(--ivoire)] font-medium">Attention au présent</span> — observation des sensations, des sons, du souffle.</li>
        </ul>
      </section>

      <section className="mt-8">
        <p className="font-mono text-[10px] tracking-widest uppercase text-[color:var(--sauge-light)] mb-3">Ambiances sonores</p>
        <p className="text-sm text-[color:var(--ivoire-muted)] leading-relaxed">
          Bruits rose, brun, pluie et océan sont générés en direct par le navigateur via l'API Web Audio.
          Aucun fichier audio externe n'est utilisé dans cette version.
        </p>
      </section>

      <section className="mt-8">
        <p className="font-mono text-[10px] tracking-widest uppercase text-[color:var(--sauge-light)] mb-3">Pour aller plus loin</p>
        <ul className="space-y-2 text-sm">
          <li>
            <a data-testid="ref-nhs" href="https://www.nhs.uk/mental-health/self-help/guides-tools-and-activities/breathing-exercises-for-stress/" target="_blank" rel="noopener noreferrer" className="text-[color:var(--sauge-light)] underline underline-offset-4">
              NHS — Exercices respiratoires
            </a>
          </li>
          <li>
            <a data-testid="ref-nccih" href="https://www.nccih.nih.gov/health/relaxation-techniques-what-you-need-to-know" target="_blank" rel="noopener noreferrer" className="text-[color:var(--sauge-light)] underline underline-offset-4">
              NCCIH — Techniques de relaxation
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
}
